export default function decimalStringToPercentageNumber(percentage?: string): number | undefined {
  if (!percentage) {
    return undefined
  }
  const float = parseFloat(percentage) * 100
  return parseFloat(float.toFixed(1))
}
